import { Slash } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import ProgressButton from '@/components/common/progress-button';
import { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';

interface Props {
  isLoading: boolean;
}

export function ConversationBanned({ isLoading }: Props) {
  const { t } = useTranslation();
  const { handleCheckStatus } = useConversationHandlers();

  return (
    <div className='flex flex-1 items-center gap-2 px-5 py-3'>
      <div className='flex flex-1 items-center gap-2 rounded-2xl'>
        <Slash className='size-4' />

        <span className='text-h3'>{t('conversation.placeholder-banned')}</span>
      </div>

      <ProgressButton
        as='button'
        isLoading={isLoading}
        className='btn-outline btn-secondary !text-secondary btn-sm text-h3 desktop:text-body1'
        onClick={() => handleCheckStatus()}
        label='conversation.check-ban-status'
      />
    </div>
  );
}
